import React, { useEffect, useState, useRef } from "react";
import { useSelector } from 'react-redux';
import { Chart } from "react-google-charts";
import TapSelect from "../../../components/ui/TapSelect";
import HttpAPICall from '../../../services/HttpAPICall';
import tapIcon from "../../../services/TapIcon";
import moment from "moment";
import UpdateMyDashboardForm from "../../settings/configurationGeneral/myDashboard/UpdateMyDashboardForm";
import Loader from "../../../components/ui/Loader/Loader";
import { APP_BASE_URL_2, INVENTORY_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import DateService from "../../../services/DateService";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import TapHelper from "../../../services/TapHelper";
import CurrencyFormatter from "../../../services/CurrencyFormatter";

const LogisticExpenseWidget = (props) => {

    const widgetUrl = APP_BASE_URL_2 + "/logistic/logistic_expense_widget" 
    const updateMyDashboardRef = useRef();
    const access_token = useSelector(state => state.auth.access_token);
    const widget_keys = useSelector(state => state.app.user_info?.widget_keys || []);
    const periods = useSelector(state => state.app && state.app.all_periods ?
        [...state.app.all_periods.map((s) => ({ value: s.key, label: `${s.display}` }))] : []);

    const [widgetData, setWidgetData] = useState(null)

    const [formData, setFormData] = useState({
        all_periods: [],
        userFilters: [
            { value: 'tagged_me', label: 'My Tagged Logistic Expense' },
            { value: 'created_by_me', label: 'Logistic Expense Created By Me' },
        ],
        filterData: {
            canChange: false,
            tagged_user_filter: "",
            date_range :""
        }
    });

    const [logisticExpenseData, setLogisticExpenseData] = useState({
        loading: false,
        data: [],
        remark_time: '',
    });
    const [reload, setReload] = useState(false);


    useEffect(() => {
        if (!formData.filterData.canChange) return;
        logisticExpenseWidgetData();
    }, [formData.filterData]);

    useEffect(() => {
        setFormData(pre => ({
            ...pre,
            all_periods: periods
        }))
        const widget =
            widget_keys?.length > 0
                ? widget_keys.find(w => w.key === "logistic_expense_widget")
                : null;

        setWidgetData(widget);
    }, []);

    useEffect(() => {
        setLogisticExpenseData(prev => ({ ...prev, loading: true }));

        const cache = localStorage.getItem('logisticExpenseWidget');

        if (cache) {
            const parsed = JSON.parse(cache);

            const diff = DateService.differenceInSeconds(
                moment(parsed.time, 'DD-MM-YYYY HH:mm A').format()
            );

            if (diff <= 86400) {
                setLogisticExpenseData({
                    data: parsed.data,
                    loading: false,
                    remark_time: parsed.time,
                });
                return;
            } else {
                localStorage.removeItem('logisticExpenseWidget');
            }
        }

        // ONLY runs if no valid cache
        logisticExpenseWidgetData();

    }, []);

    useEffect(() => {
        if (!reload) return;

        logisticExpenseWidgetData();
        setReload(false);

    }, [reload]);

    
    const logisticExpenseWidgetData = () => {
        setLogisticExpenseData(prev => ({ ...prev, loading: true }));

        let params = {
            ...formData.filterData,
            reload: reload ? 'reload' : false
        };

        HttpAPICall.withAthorization('GET', widgetUrl, access_token, params, {}, (response) => {
            const res = response.data;
            setLogisticExpenseData(prev => ({
                ...prev,
                data: res.data,
                remark_time: res.time
            }));
           // if (reload) {
                localStorage.setItem('logisticExpenseWidget', JSON.stringify(res));
           // }
        }).then(() => {
            setLogisticExpenseData(prev => ({ ...prev, loading: false }));
            setReload(false);
            setFormData(prev => ({
                ...prev,
                filterData: {
                    ...prev.filterData,
                    canChange: false
                }
            }))
        });
    };

    const pinMyDashboardHandler = (widgetData = null) => {
        updateMyDashboardRef.current.updateMyDashboardModalInit(widgetData, {
            key: "logistic_expense_widget",
            name: "Logistic Expense Widget"
        });
    };

    const handleCountClick = (data) => {
        const logistic_category = data.id;
        const logistic_type = data.type;
        const taggedUserFilter = formData.filterData.tagged_user_filter;
        const dateRange = formData.filterData.date_range;

        const params = new URLSearchParams();
        if (logistic_category) {
            params.append('logistic_category', logistic_category);
        }
        if (logistic_type) {
            params.append('logistic_type', logistic_type);
        }
        if (taggedUserFilter) {
            params.append('tagged_user_filter', taggedUserFilter);
        }
         if (dateRange ) {
            params.append('date_range', dateRange);
        }

        const url = `/logistic_list?${params.toString()}`;
        window.open(url, '_blank');
    };

    const totalValue = logisticExpenseData.data.reduce((acc, d) =>
        acc + (parseInt(d.total_logistics) > 0 ? parseInt(d.total_logistics) : 0), 0);

    return (
        <div className="card mt-3">
            <div className="card-body">
                <div className="row">
                    <div className="col-5">
                        <h6 className="fw-bold primary_color mb-0">Logistic Expense Widget</h6>
                    </div>
                    <div className="col-3">
                        <TapSelect
                            options={formData.userFilters}
                            changeEvent={(selectedOption) => {
                                setFormData(prev => ({
                                    ...prev,
                                    filterData: {
                                        ...formData.filterData,
                                        canChange: true,
                                        tagged_user_filter: selectedOption ? selectedOption.value : ""
                                    }
                                }));
                            }}
                            value={formData.userFilters.find(u => u.value === formData.filterData.tagged_user_filter)}
                            isSearchable={true}
                            isClearable={true}
                            containerHeight="33px"
                            fontSize="93%"
                            width="100%"
                            placeholder="All Logistic "
                        />
                    </div>
                    <div className="col-3 p0">
                        <TapSelect
                            options={formData.all_periods}
                            changeEvent={(selectedOption) => {
                                setFormData(pre => ({
                                    ...pre,
                                    filterData: {
                                        ...formData.filterData,
                                        canChange: true,
                                        date_range: selectedOption ? selectedOption.value : ""
                                    }
                                }))
                            }}
                            value={formData.all_periods.find(u => u.value == formData.filterData.date_range)}
                            isSearchable={true}
                            isClearable={true}
                            containerHeight="33px"
                            fontSize="93%"
                            width="99%"
                            placeholder="All Periods"
                        />
                    </div>
                    <div className="col-1 px-0 mx-0 text-center">
                        <div className="dropdown">
                            <tapIcon.imageIcon
                                icon={tapIcon.ListActionIcon}
                                alt="action-icon"
                                className="img-fluid px-2 btn btn-light btn-block"
                                data-bs-toggle="dropdown"
                                href="#"
                                role="button"
                                aria-expanded="false"
                            />
                            <ul className="dropdown-menu dropdown-menu-end">
                                <li className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => setReload(true)}>
                                    Refresh
                                </li>
                                <li className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => pinMyDashboardHandler(widgetData)}>
                                    {!widgetData ? "Pinned to My Dashboard" : "Unpinned from My Dashboard"}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="row mt-2">
                    <div className="col-6">
                        <div style={{ overflowY: "auto", maxHeight: "300px" }}>
                            <table className="table table-hover table-bordered  bg-white">
                                <thead className="table-secondary">
                                    <tr className="text-center">
                                        <th style={{ width: "33%" }} className="text-start" >Logistic Category</th>
                                        <th style={{ width: "33%" }}>No. of Consignments</th>
                                        <th style={{ width: "33%" }}> Cost incurred</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {logisticExpenseData.loading
                                        ? <tr> <td className="text-center" colSpan="3"><Loader /></td></tr>
                                        :
                                        logisticExpenseData.data.length > 0
                                            ?
                                            logisticExpenseData.data.map((d, i) => (
                                                <tr key={i}>
                                                    <td>{d.name}</td>
                                                    <td className="text-center">
                                                        {d.total_logistics ?
                                                            <>
                                                                <span
                                                                    className=" text-primary"
                                                                    style={{ cursor: 'pointer' }}
                                                                    onClick={() => handleCountClick(d)}
                                                                >
                                                                    {d.total_logistics}
                                                                </span>
                                                            </>
                                                            : "-"}
                                                    </td>
                                                    <td className="text-end">
                                                        <CurrencyFormatter currencyCode={props.default_currency} amount={parseInt(d?.total_amount)} />
                                                    </td>
                                                </tr>
                                            ))
                                            :
                                            <tr> <td className="text-center" colSpan="3">No Record Found</td></tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="col-6 p0 mt-3 mb-1">
                        {logisticExpenseData.loading
                            ? <Loader />
                            :
                            (logisticExpenseData.data && totalValue > 0 ? (
                                <Chart
                                    chartType="PieChart"
                                    data={[['Status Name', 'Demand Count']].concat(logisticExpenseData.data.map((d) => { return [d.name, d.total_logistics]; }))}
                                    options={{
                                        legend: { position: 'labeled', labeledValueText: 'both' },
                                        pieSliceText: 'none',
                                        chartArea: { width: '90%', height: '90%' },
                                    }}
                                    rootProps={{ 'data-testid': '1' }} />
                            ) : null)}

                    </div>
                </div>

                <div className="col-sm-12 text-muted fs11">
                    Report as of {logisticExpenseData.remark_time}
                </div>
            </div>
            <UpdateMyDashboardForm ref={updateMyDashboardRef} />
        </div>
    );
};

export default LogisticExpenseWidget;